import { Typography } from 'antd';
import React from 'react';

export const TooltipText = ({ ellipsis, className, children, ...rest }) => {
    return (
        <Typography.Paragraph
            ellipsis={ellipsis}
            className={className}
            {...rest}
        >
            {children}
        </Typography.Paragraph>
    );
};
